export default __webpack_public_path__ + "static/media/mercedes1.24b60330.jpeg";